


































































import Vue from "vue";
import youtube from "@/apis/youtube";

// Icons
import YTLogo from "./icons/YTLogo.vue";
import YTAddVideo from "./icons/YTAddVideo.vue";

// Components
import YTSearchBox from "./YTSearchBox.vue";
import Button from "@/components/Landing/Button.vue";

export default Vue.extend({
	name: "YTHeader",

	components: {
		YTLogo,
		YTSearchBox,
		YTAddVideo,
		Button,
	},
	data() {
		return {
			q: "",
			showSuggestions: false,
			recentSearches: ["hello", "new songs", "gaming videos"],
			suggestions: [],
		};
	},
	watch: {
		q(q: String) {
			this.getSuggestions(q);
		},
	},
	methods: {
		onClickSuggestionItem(q: string) {
			this.q = q;
			this.showSuggestions = false;
			this.$router.push(`/apps/cloned/youtube/search?q=${q}`);
		},
		async getSuggestions(q: String) {
			let { error, data } = await youtube.suggestions({ q });
			if (error) return;
			this.suggestions = data[1];
			this.showSuggestions = true;
		},
	},
});
